//------------------------------------------------------------------------------
// This file is auto-generated.
//------------------------------------------------------------------------------
// This file was generated by NTypewriter from the C# ViewModel class with the
// same class/interface name.
//
// Do not change this file.  Any changes may cause incorrect behaviour and will
// be lost if the code is regenerated.
//------------------------------------------------------------------------------

import { ItemBase } from '../internal/ItemBase';
import { TransactionType } from './Enums';

export class TransactionSearchOptions extends ItemBase {
    IDs: string[] = [];
    FamilyIDs: string[] = [];
    StudentIDs: string[] = [];
    EventCategoryIDs: string[] = [];
    SearchText: string | null = null;
    SearchAmount: number | null = null;
    TransactionTypes: TransactionType[] = [];
    MinDate: string | null = null;
    MaxDate: string | null = null;
    ZeroAmount: boolean | null = null;

    constructor(initializer?: Partial<TransactionSearchOptions>) {
        super();
        if (initializer) {
            Object.assign(this, initializer);
        }
    }

    static readonly ClassName: string = "TransactionSearchOptions";
}
